import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source, Marker } from 'react-mapbox-gl'
import { makeGetMarker } from '../selectors/markerSelector'

const Svg = require('../assets/marker.svg')
const size = 42

class MarkerLayer extends Component {
  render () {
    const { markerLngLat } = this.props
    if (!markerLngLat || !markerLngLat.lng) {
      return null
    }
    
    return (
      <Marker coordinates={[markerLngLat.lng, markerLngLat.lat]} >
        <img src={Svg.default} alt={'marker'} height={size} width={size} />
      </Marker>
    )
  }
}

const makeMapStateToProps = () => {
  const getMarker = makeGetMarker()

  const mapStateToProps = (state, ownProps) => {
    const { id } = ownProps
    return {
      markerLngLat: getMarker(state, id)
    }
  }

  return mapStateToProps
}

export default connect(makeMapStateToProps, null)(MarkerLayer)



// WEBPACK FOOTER //
// ./src/layers/MarkerLayer.js